import { useContext } from "react";
import { AutomaticSummarizationContext } from "../contexts/AutomaticSummarizationContext";

export const useAutomaticSummarization = () => {
  return useContext(AutomaticSummarizationContext);
};
